var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1824 2.4V3.01765H16.8H19.7824V11.3824H10.8H10.1824V12V22.8C10.1824 23.1189 9.91888 23.3824 9.6 23.3824H7.2C6.88112 23.3824 6.61765 23.1189 6.61765 22.8V10.2176H18H18.6176V9.6V4.8V4.18235H18H16.8H16.1824V4.8V6C16.1824 6.31888 15.9189 6.58235 15.6 6.58235H1.2C0.881117 6.58235 0.617647 6.31888 0.617647 6V1.2C0.617647 0.881117 0.881117 0.617647 1.2 0.617647H15.6C15.9189 0.617647 16.1824 0.881117 16.1824 1.2V2.4Z",
    stroke: "black",
    strokeWidth: 1.23529
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.5113c08845d9926a65bab75de3f7c1f3.svg";
export { ForwardRef as ReactComponent };